import React from "react";
import client from "@culturehq/client";
import { Panel, Tooltip } from "@culturehq/components";

import { useFetch } from "app/hooks";
import { t, Trans } from "app/utils";

import icon from "images/badges/receive-recognition.png";

import ErrorBoundary from "components/common/ErrorBoundary";
import Trophy from "components/common/Trophy";
import UserName from "components/common/UserName";

const MostRecognized = () => {
  const { fetching, json } = useFetch(client.listRecognitionsRecognizedUsers);
  const { users = [] } = json;

  return (
    <Panel className="SidePanel">
      <Panel.Heading>
        <Tooltip tip={t("The people who have been recognized by colleagues the most within the last 30 days.")}>
          <img src={icon} alt={t("Most Recognized")} />
          {" "}
          <Trans>Most Recognized</Trans>
        </Tooltip>
      </Panel.Heading>
      <Panel.LoaderBody loading={fetching}>
        <ErrorBoundary>
          {users.map((user, index) => (
            <div key={user.id} className="SidePanel__row">
              <Trophy place={index + 1} />
              <UserName user={user} />
            </div>
          ))}
        </ErrorBoundary>
      </Panel.LoaderBody>
    </Panel>
  );
};

export default MostRecognized;
